import dayjs from "dayjs";

const DATE_FORMAT = "YYYY-MM-DD";

// Year-to-date, matching the DateRangeFilter preset already offered on the
// Invoice Dashboard (§5.4).
export const getDefaultDateRange = () => ({
  startDate: dayjs().startOf("year").format(DATE_FORMAT),
  endDate: dayjs().format(DATE_FORMAT),
});

// A range is valid when both dates parse and the range is not inverted (§4.5).
export const isValidRange = ({ startDate, endDate } = {}) => {
  const start = dayjs(startDate, DATE_FORMAT, true);
  const end = dayjs(endDate, DATE_FORMAT, true);
  if (!start.isValid() || !end.isValid()) return false;
  return !end.isBefore(start, "day");
};

// D5: comparison window is the L days ending the day before startDate, where L
// is the current range's length in days (inclusive). Handles single-day ranges
// and leap years correctly since it is pure date arithmetic via dayjs.
export const getPrecedingPeriod = ({ startDate, endDate }) => {
  if (!isValidRange({ startDate, endDate })) {
    throw new Error(`Invalid date range: ${startDate} - ${endDate}`);
  }

  const start = dayjs(startDate, DATE_FORMAT, true);
  const end = dayjs(endDate, DATE_FORMAT, true);
  const lengthInDays = end.diff(start, "day") + 1;

  const compareEndDate = start.subtract(1, "day");
  const compareStartDate = compareEndDate.subtract(lengthInDays - 1, "day");

  return {
    compareStartDate: compareStartDate.format(DATE_FORMAT),
    compareEndDate: compareEndDate.format(DATE_FORMAT),
  };
};

// Combines the current range with its D5 comparison window — the shape every
// AABI fetch sends (§4.2, §4.3).
export const buildPeriodParams = ({ startDate, endDate }) => {
  const { compareStartDate, compareEndDate } = getPrecedingPeriod({
    startDate,
    endDate,
  });
  return { startDate, endDate, compareStartDate, compareEndDate };
};
